import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getPagamento, getPagamentoById, postPagamento } from "@/services/pagamento";
import { Button as AntdButton, message } from "antd";
import { Input } from "@/components/ui/inputForm";
import { Table, Switch, Space, ConfigProvider, theme } from "antd";
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { usePermissions } from "@/hooks/usePermissions";

export default function ConsultaPagamento() {
  const [pagamentos, setPagamentos] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const { canInsert, canEdit } = usePermissions();

  useEffect(() => {
    handleGetPagamentos();
  }, []);
  
  const handleGetPagamentos = async () => {
    const { data } = await getPagamento();
    setPagamentos(data.map((p: any) => ({ ...p, ativo: p.ativo ?? true })));
  };

  const handleAdd = useCallback(() => {
    navigate("/pagamento/cadastro");
  }, [navigate]);

  const handleEdit = (id: string) => {
    navigate(`/pagamento/${id}`);
  };

  const toggleAtivo = async (id: string) => {
    try {
      const { data: pagamento } = await getPagamentoById(id);
      const updatedPagamento = { ...pagamento, ativo: !pagamento.ativo };
      const response = await postPagamento(updatedPagamento);
      
      if (response.status === 200 || response.status === 201) {
        setPagamentos((prev) =>
          prev.map((p) => (p.id === id ? { ...p, ativo: !p.ativo } : p))
        );
        message.success(`Pagamento ${!pagamento.ativo ? 'ativado' : 'inativado'} com sucesso!`);
      } else {
        message.error("Falha ao atualizar o status.");
      }
    } catch (error) {
      message.error("Erro ao comunicar com o servidor.");
    }
  };

  const columns = [
    { title: "Nome", dataIndex: "nome", key: "nome" },
    { title: "Tipo", dataIndex: "tipoPagamento", key: "tipoPagamento" },
    { title: "Quantidade Máx. Parc.", dataIndex: "quantidadeParcelas", key: "quantidadeParcelas" },
    {
      title: "Status",
      dataIndex: "ativo",
      key: "ativo",
      render: (value: boolean, record: any) => (
        <Switch 
          checked={!!value} 
          onChange={() => toggleAtivo(record.id)} 
          checkedChildren="Ativo" 
          unCheckedChildren="Inativo"
        />
      ),
    },
    {
      title: "Ação",
      key: "acao",
      render: (_: any, record: any) => (
        <Space size="middle">
          {canEdit(9) && (
            <AntdButton type="text" icon={<EditOutlined />} onClick={() => handleEdit(record.id)} />
          )}
        </Space>
      ),
    },
  ];

  const filteredPagamentos = pagamentos.filter((p) =>
    p.nome?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="mb-8">
        <span className="text-white text-2xl">Consulta de Formas de Pagamento</span>
      </div>
      <ConfigProvider theme={{ algorithm: [theme.compactAlgorithm, theme.darkAlgorithm] }}>
        <div className="flex gap-8 items-end mb-8">
          <Input
            type="text"
            placeholder="Pesquisar por nome"
            className="w-80"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {canInsert(9) && (
            <AntdButton className="flex gap-2" onClick={handleAdd}>
              Novo
              <PlusOutlined />
            </AntdButton>
          )}
        </div>
        <Table columns={columns} dataSource={filteredPagamentos} rowKey="id" />
      </ConfigProvider>
    </>
  );
}
